import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
// import { Pagination } from "react-bootstrap";
import { getRequest } from "services/api";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const AgentContext = createContext();

export const AgentProvider = ({ children }) => {
  const [agents, setAgents] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    limit: 500,
    // limit: LIMIT_DATA_PER_PAGE,
    // tambahkan "include":"products"
    include: "products",
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchAgents = useCallback(async () => {
    setAgents((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/agent${queryString}`);
      if (response.success) {
        setAgents({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });

        setFilterOptions((prev) => ({
          ...prev,
          totalPages: response.pagination.last_page,
        }));
      }
    } catch (error) {
      setAgents({
        data: [],
        pagination: null,
        error: error.message,
        loading: false,
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = agents.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  return (
    <AgentContext.Provider
      value={{
        agents,
        filterOptions,
        handleSearch,
        // fetchAgents,
        refetch: fetchAgents,
        Pagination,
      }}
    >
      {children}
    </AgentContext.Provider>
  );
};
export const useAgent = () => {
  const context = useContext(AgentContext);
  if (!context) {
    throw new Error("useAgent must be used within AgentProvider");
  }

  const fetchOptions = async (inputValue) => {
    const response = await getRequest(`/agent?search=${inputValue}`);
    if (response.success) {
      return response.data.map((agent) => ({
        value: agent.id,
        label: agent.name,
      }));
    }
    return [];
  };
  // return context;
  return { ...context, fetchOptions };
};
